<style>
	.navBox{
    width:100%;
    height:60px;
    background: linear-gradient(136deg, #FF923E 0%, #FF6F00 100%);
    position: relative;
    min-width:1440px;
  }
  .nav{
    width:1440px;
    margin:0 auto;
    height:auto;
    position: relative;
  }

  .navLeft{
    float:left;
    width:auto;
    height:60px;
    position: relative;
    cursor: pointer;
  }
  .logo{
    width:37px;
    height:37px;
    position: relative;
    top:12px;
    float:left;
  }
  .logo img{
    width:100%;
    height:100%;
  }
  .navLeft .title{
    width:auto;
    position: relative;
    height:37px;
    line-height: 37px;
    font-size:25px;
    font-family:PingFang SC;
    font-weight:bold;
    color:#fff;
    float:left;
    top:12px;
    margin-left:10px;
  }
  .navText{
    height:22px;
    width:auto;
    float:left;
    position: relative;
    top:27px;
    line-height: 22px;
    color:#fff;
    font-family:PingFang SC;
    font-weight:400;
    font-size:16px;
	margin-left:15px;
  }
  .navRight{
    float:right;
    height:60px;
    width:auto;
    position: relative;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }
  .navList{
    width:auto;
    position: relative;
    float:right;
    height: 60px;
    margin-right:60px;
  }
  .navList .more{
    position: relative;
  }
  .navList .more ul{
    position: absolute;
    left: -20px;
    top: 60px;
    background-color: #fff;
    z-index: 2;
    width: 128px;
    padding: 10px 0;
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
    border-radius:6px;
  }
  .navList .more ul li{
    height: 50px;
    line-height: 50px;
    color: #333;
  }
  .navList .more ul li:hover{
    background-color: #EBEAF8;
  }
  .navListItem{
    height:60px;
    width:auto;
    padding:0 20px;
    margin:0 10px;
    float:left;
    line-height: 60px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:#fff;
    position: relative;
    cursor: pointer;
  }
  .navListItem div{
    height:4px;
    width:100%;
    border-radius: 2px;
    background: #fff;
    position: absolute;
    left:0;
    bottom: 6px;
  }
  .mobile_navList {
  	display: none;
  }
  .navBoxOther {
  	display: none;
  }
  .personCenter{
    float: right;
    display: flex;
    align-items: center;
    height: 60px;
    color: #fff;
    cursor: pointer;
  }
  .personCenter > div{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 4px;

  }
  .personCenter > div img{
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width:500px ) {
  	html,body {
  		width: 100%;
  		height: 60px;
  	}
 	.navBox {
 		position: fixed;
    top: 0;
 		min-width: 100%;
 		height: 40px;
 		z-index: 1000;
 	}
 	.navBox .nav {
 		width: 100%;
 		height: auto;
 	}
 	.navBox .navLeft {
 		height: 40px;
 	}
 	.navBox .navLeft .logo {
 		height: 24px;
 		width: 24px;
 		left: 12px;
 		top: 8px;
 	}
 	.navBox .navLeft .logo img {
 		width: 24px;
 		height: 24px;
 	}
 	.navBox .navLeft .title {
 		height: 40px;
 		line-height: 40px;
 		top: 0;
 		font-size:15px;
 		margin-left: 20px;
 	}
 	.navBox .navLeft .navText {
 		display: none;
 	}
 	.navBox .navRight {
 		height:40px;
    	width:auto;
    	margin-right: 48px;
 	}
 	.navBox .navList {
 		display: none;
 	}
 	.navBox .mobile_navList {
 		position: absolute;
 		display: block;
 		width: 25px;
 		height: 25px;
 		float: right;
 		right: 14px;
 		top: 7px;
 	}
 	.navBox .mobile_navList > img {
 		width: 25px;
 		height: 21px;
 		margin-top: 2px;
 	}
 	.navBox .navBoxOther {
 		display: block;
 		position: fixed;
 		top: 40px;
 		left: 0;
 		right: 0;
 		bottom: 0;
 		width: 100%;
 		height: 100%;
 		background-color: #FFFFFF;
 		z-index: 1000;
 	}
 	.navBox .navBoxOther .navBoxOtherItem {
 		width: 100%;
 		height: 51px;
 		line-height: 51px;
 		font-size: 18px;
   }
   .personCenter{
     display: none;
   }
  }
</style>

<template>
	<div class='navBox'>
    <div class='nav'>
      <div class='navLeft' @click="changeNow" data-now='首页'>
        <div class='logo'>
          <img src="../assets/logo.png">
        </div>
        <div class='title'>门窗柜</div>
        <!-- <span class='navText'>现货快送，板材共享</span> -->
        <span class='navText'>定制工业互联网</span>
      </div>
      <div class='navRight'>
        <user-login v-show="0" ref="login" @logout='logout'></user-login>
        <div class="personCenter" @click='changeNow' data-now='personalCenter'>
          <div><img :src="userData.logo_url ? userData.logo_url:require('../assets/logo.png')" alt=""></div>
          <span>个人中心</span>
        </div>
        <div class='navList'>
          <div @click='changeNow' :data-now='item.id' class='navListItem' v-for='(item,index) in list' :key="index" :style="$route.name==item.id ? 'font-weight:bold':''">{{item.name}}<div v-show='$route.name==item.id'></div></div>
          <!-- <div class="more navListItem" @mouseover="showTopSelect = true" @mouseleave="showTopSelect = false">
            <span>更多&nbsp;<img v-show="!showTopSelect" src="../assets/icon_down.png" alt=""><img v-show="showTopSelect" src="../assets/icon_up.png" alt=""></span>
            <ul v-show="showTopSelect">
              <li v-for="items in more" @click='changeNow' :data-now='items' :key="items">{{items}}</li>
            </ul>
          </div> -->
        </div>
      </div>
      <div class='mobile_navList'>
         	<img @click="showTopMenuNow" v-if="!showTopMenu" src="../assets/button_main_n.png" alt="" />
         	<img @click="showTopMenuNow" v-if="showTopMenu" src="../assets/icon_chacha_n.png" alt="" />
       </div>
    </div>
    <!--大页面跳转-->
    <!-- <div class="navBoxOther" v-if="showTopMenu">
    	<div @click='changeNow' :data-now='item' class="navBoxOtherItem" :style="now==item?'background-color:#6851FF;color:#ffffff;font-weight:bold;':''" v-for="(item,index) in list">{{item}}</div>
      <div v-for="items in modelMore" @click='changeNow' :data-now='items' class="navBoxOtherItem" :key="items">{{items}}</div>
    	<div @click="loggedout" class="navBoxOtherItem">退出登录</div>
    </div> -->
  </div>
</template>

<script>
  import login from  './Login.vue'
  import { mapMutations, mapState } from 'vuex'
	export default {
		components:{
      "user-login":login
		},
		props:['now','title'],
		data() {
			return {
        list:[{
          name: '同城仓库',
          id: 'Shop'
        }, {
          name: '社区网点',
          id: 'showRoom'
        }, {
          name: '安装测量',
          id: 'TheWorld'
        }, {
          name: '设计软件',
          id: 'aboutSoftware'
        },{
          name: '加盟',
          id: 'join'
        }, {
          name: '消费者服务',
          id: 'moreVipServer'
        },{
          name: '关于门窗柜',
          id: 'aboutCloud'
        }],
        more:['包小区','测量安装'],
        modelMore:['包小区','测量安装','加盟云仓','个人中心'],
        showTopMenu:false,
        showTopSelect:false,
        // userData:{}
			}
		},
		computed: {
      ...mapState({
        userData: 'userInfo',
        userDfv: 'userDfv'
      }),
    },
    created() {
      if (this.userDfv) {
        this.list = [];
      }
    },
		mounted() {
      
		},
		methods: {
      ...mapMutations([
        'logout', 'changeNavNow'
      ]),
      openMore(){
        this.showTopSelect = !this.showTopSelect
      },
			showTopMenuNow(){
				let that = this
	    		if(that.showTopMenu == true){
	    			that.showTopMenu = false
	    			return
	    		}
	    		that.showTopMenu = true
			},
      // logout(){
      //   this.$emit("logout")
      // },
      // logon(){
      //   this.$refs.login.logon();
      //   if(localStorage.data){
      //     this.userData = JSON.parse(localStorage.data)
      //     console.log(this.userData)
      //   }
      // },
      changeNow(e){
        let that=this
        this.showTopSelect = false
        let now=e.currentTarget.dataset.now
        if(now==that.now){
          return
        }
        that.showTopMenu = false
        // if(now == '供应商管理'){
        //   if(!that.$store.state.supplierInfo){
        //     this.$message({
        //       message:'您还不是供应商',
        //       duration:1000
        //     })
        //     return
        //   }

        // }
        switch(now){
          case 'aboutCloud':
            this.$router.replace({
              name: 'aboutCloud'
            })
            return;
          case 'moreVipServer':
            this.$router.replace({
              name: 'moreVipServer'
            })
            return;
          case 'Shop':
            this.$router.replace({
              name: 'Shop'
            })
            return;
          case "TheWorld":
            this.$router.replace({
              name: 'TheWorld'
            })
            return
          case 'showRoom':
            this.$router.replace('/showRoom')
            return
          case 'join':
            this.$router.replace({
              name: 'join'
            });
            return
          case 'aboutSoftware':
            this.$router.replace({
              name: 'aboutSoftware'
            });
            return
          default:
            this.$router.replace({
              name: 'Shop'
            });
        }
        if(now == 'personalCenter'){
          // 未登录状态
          if(!localStorage.data){
            let pageTo=encodeURIComponent(location.href)
			      if(process.env.NODE_ENV=="development"){
			        location.href = 'http://localhost:8010/login.html?other=true&pageTo=' + pageTo
			      }else{
			        location.href='./login.html?pageTo='+pageTo
			      }
            return
          }else{
            this.$router.replace({
              name: 'personalCenter'
            })
          }
        }
      },
      loggedout(){
      	 this.$refs.login.logout()
      }
		}
	}
</script>
